import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UploadProgressDialogComponent, UploadProgressData } from 'app/drake-components/file-manager/upload-progress-dialog/upload-progress-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ProgressDialogService {
  private dialogRef: MatDialogRef<UploadProgressDialogComponent>;

  constructor(private dialog: MatDialog) {}

  open(total: number): void {
    this.dialogRef = this.dialog.open(UploadProgressDialogComponent, {
      disableClose: true,
      data: { total, progress: 0 }
    });
  }

  update(progress: number, currentFileName?: string): void {
    if (this.dialogRef && this.dialogRef.componentInstance) {
      this.dialogRef.componentInstance.data.progress = progress;
    }
    if (currentFileName) {
      this.dialogRef.componentInstance.data.currentFileName = currentFileName;
    }
  }

  close(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
}
